<h3 mat-dialog-title>{{ 'reminder.tourReminder' | translate }}</h3>

<mat-dialog-content fxLayout="column" fxLayoutGap="1rem">
  <div fxLayout="row" fxLayoutGap="0.25rem">
    <div>
      <h4>{{ 'core.customer' | translate }}:</h4>
      <h4>{{ 'core.constructionSite' | translate }}:</h4>
      <h4>{{ 'reminder.date' | translate }}:</h4>
    </div>

    <div>
      <h4>{{ reminder.tour.customer.name }}</h4>
      <h4>{{ reminder.tour.constructionSite.name }}</h4>
      <h4>{{ reminder.tour.appointment.date | date }}</h4>
    </div>
  </div>

  <h5 class="reminder-text">{{ reminder.text }}</h5>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button matDialogClose color="primary" (click)="onConfirm()">
    {{ 'core.confirmBtn' | translate }}
  </button>
</mat-dialog-actions>
